import { CircularProgress } from '@mui/material';

import './styles.scss';

type ReportsLoadingType = {
  label?: string;
  isNoLabel?: boolean;
};

export const ReportsLoading = ({
  label = 'Calculating...',
  isNoLabel = false,
}: ReportsLoadingType) => {
  return (
    <div className="reports-loading-container">
      <div className="reports-loading">
        <CircularProgress className="circular-progress" />
        <span>{!isNoLabel ? label : ''}</span>
      </div>
    </div>
  );
};
